import type { UseCreateCardCollapseArgs } from '../interfaces';


export const useCreateCardCollapse = ({
  createCardRef,
  isCreateOpen,
  setIsCreateOpen,
}: UseCreateCardCollapseArgs) => {
  void createCardRef;
  void isCreateOpen;
  void setIsCreateOpen;
};
